import React from "react";

import "./Projects.css";

import project1 from "../../uploads/fidin img pdf_page-0008.jpg";
import project2 from "../../uploads/fidin img pdf_page-0009.jpg";
import project3 from "../../uploads/fidin img pdf_page-0010.jpg";

const Projects = () => {

  return (

    <div className="projects-page">

      {/* HERO */}

      <section className="projects-hero">

        <h1>Our Projects</h1>

        <p>
          Building Dreams Into Reality
        </p>

      </section>

      {/* MAIN */}

      <div className="projects-container">

        <h2 className="section-title">
          Ongoing & Representative Projects
        </h2>

        <p className="section-subtitle">
          Infrastructure, Renewable Energy & EPC Development Across India
        </p>

        {/* GRID */}

        <div className="project-grid">

          {/* PROJECT 1 */}

          <div className="project-card">

            <img
              src={project1}
              alt="Solar Power Plant"
            />

            <div className="project-info">

              <span className="status ongoing">
                Under Development
              </span>

              <h3>
                50 MW Solar Power Plant - Maharashtra
              </h3>

              <p>
                <strong>Scope:</strong>
                {" "}Complete EPC execution
              </p>

              <p>
                Utility-scale solar project with advanced
                tracking systems designed for long-term
                performance and maximum energy output.
              </p>

            </div>

          </div>

          {/* PROJECT 2 */}

          <div className="project-card">

            <img
              src={project2}
              alt="Transmission Line"
            />

            <div className="project-info">

              <span className="status ongoing">
                Execution Phase
              </span>

              <h3>
                132 kV Transmission Line Project
              </h3>

              <p>
                <strong>Scope:</strong>
                {" "}Transmission line construction & integration
              </p>

              <p>
                High voltage transmission infrastructure
                connecting renewable energy sources to
                the grid with full compliance standards.
              </p>

            </div>

          </div>

          {/* PROJECT 3 */}

          <div className="project-card">

            <img
              src={project3}
              alt="Industrial Project"
            />

            <div className="project-info">

              <span className="status planning">
                Planning Stage
              </span>

              <h3>
                Industrial Infrastructure Project
              </h3>

              <p>
                <strong>Scope:</strong>
                {" "}Engineering and project planning
              </p>

              <p>
                Integrated industrial facility development
                with power distribution, utilities and
                comprehensive infrastructure systems.
              </p>

            </div>

          </div>

        </div>

        {/* NOTE */}

        <div className="note">

          More project details will be updated as execution progresses.

        </div>

      </div>

    </div>
  );
};

export default Projects;